export default "__VITE_ASSET__BnId1Xhf__"